import "./App.css";
import Navbar from "./Layout/Navbar";
import About from "./Component/About";
import Services from "./Component/Services";
import Activity from "./Component/Activity";
import Testimonials from "./Component/Testimonials";
import Contact from "./Component/Contact";
import Footer from "./Layout/Footer";
import { HashRouter, Route, Routes } from "react-router-dom";
import SCGTMemberForm from "./Component/SCGTMemberForm";
import ScrollToTopButton from "./Component/ScrollToTopButton";
import Walkininterview from "./Component/WalkInInterview";
import Home from "./Component/Home";
import Career from "./Component/Career";


function App() {
  return (
    <HashRouter>
      <div className="index-page">
        <Navbar />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Home />
                {/* <Banner /> */}
                <About />
                <Services />
                {/* <Activity /> */}
                <Testimonials />
                <Contact />

              </>
            }
          />
          <Route path="/scgt/member-form" element={<SCGTMemberForm />} />
          <Route path="/activity" element={<Activity />} />
          <Route path="/career" element={<Career />} />
          <Route path="/walk-in-interview" element={<Walkininterview />} />

        </Routes>
        <Footer />
        <ScrollToTopButton />
      </div>
    </HashRouter>
  );
}

export default App;
